import { render, staticRenderFns } from "./BtnProcessarSolicitacaoAutorizacaoEnvioForaDoPrazo.vue?vue&type=template&id=24b20f03"
import script from "./BtnProcessarSolicitacaoAutorizacaoEnvioForaDoPrazo.vue?vue&type=script&lang=js"
export * from "./BtnProcessarSolicitacaoAutorizacaoEnvioForaDoPrazo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports